import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import {
  Box,
  Breadcrumbs,
  Button,
  Container,
  Grid,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import axiosRetry from 'axios-retry';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Slider from 'react-slick';
import {secured as axios} from '../../axios';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import ServiceItemPlaceholder from '../service/ServiceItemPlaceholder';
import CommunityCard from './CommunityCard';
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const Communities = ({token, setShowNav}) => {
  const [communities, setCommunities] = useState([]);
  const [communitiesOther, setCommunitiesOther] = useState([]);
  const [seeAll, setSeeAll] = useState(false);
  const [seeAllOther, setSeeAllOther] = useState(false);
  const [isLoadingCommunities, setIsLoadingCommunities] = useState(false);
  const [showMoveUpButton, setShowMoveUpButton] = useState(false);
  const [showMoveDownButton, setShowMoveDownButton] = useState(true);
  const [anchor, setAnchor] = useState(0);
  const [isLoadingCommunitiesOther, setIsLoadingCommunitiesOther] =
    useState(false);
  useEffect(() => {
    setShowNav(true);
  }, []);

  const header = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const moveUp = () => {
    const tempPosition = anchor - 1;
    const tempAnchor = 'anchor'+tempPosition;
    const anchorEl = document.getElementById(tempAnchor);
    if (anchorEl) {
      window.scrollTo({
        top: anchorEl.offsetTop - process.env.REACT_APP_HEADER_HEIGHT,
        behavior: "smooth",
      });
      setAnchor(anchor - 1);
    }
    const nextPosition = tempPosition - 1;
    if (document.getElementById('anchor'+nextPosition) == null) {
      setShowMoveUpButton(false);
      setShowMoveDownButton(true);
    } else {
      setShowMoveUpButton(true);
      setShowMoveDownButton(true);
    }
  };

  const moveDown = () => {
    const tempPosition = anchor + 1;
    const tempAnchor = 'anchor'+tempPosition;
    const anchorEl = document.getElementById(tempAnchor);
    if (anchorEl) {
      window.scrollTo({
        top: anchorEl.offsetTop - process.env.REACT_APP_HEADER_HEIGHT,
        behavior: "smooth",
      });
      setAnchor(anchor + 1);
    }
    const nextPosition = tempPosition + 1;
    if (document.getElementById('anchor'+nextPosition) == null) {
      setShowMoveDownButton(false);
      setShowMoveUpButton(true);
    } else {
      setShowMoveDownButton(true);
      setShowMoveUpButton(true);
    }

  };

  axiosRetry(axios, {retries: 3});
  const navigate = useNavigate();
  const {mode} = useDarkMode();

  useEffect(() => {
    setIsLoadingCommunities(true);
    setIsLoadingCommunitiesOther(true);
    axios
      .get(`${axios.defaults.apiURL}/communities`, header)
      .then(function (response) {
        setIsLoadingCommunities(false);
        setCommunities(
          response.data
        );
      })
      .catch(function (error) {
        setIsLoadingCommunities(false);
        if (error.response) {
          if (error.response.status === 401) {
            localStorage.clear();
            navigate('/login');
          }
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        }
      });

    axios
      .get(`${axios.defaults.apiURL}/public-communities`, header)
      .then(function (response) {
        setIsLoadingCommunitiesOther(false);
        setCommunitiesOther(
          response.data
        );
      })
      .catch(function (error) {
        setIsLoadingCommunitiesOther(false);
        if (error.response) {
          if (error.response.status === 401) {
            localStorage.clear();
            navigate('/login');
          }
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        }
      });

    return () => {
      setCommunities([]);
      setCommunitiesOther([]);
    };
  }, []);

  const breadcrumbs = [
    <Typography
      className={'breadcrumbs'}
      variant={'body2'}
      onClick={() => navigate('/')}
      style={{color: mode.settings.breadcrumbColor1}}>
      Accueil
    </Typography>,
    <Typography variant={'body2'} style={{color: mode.settings.textColor3}}>
      Communautés
    </Typography>,
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: communities.length < 3 ? communities.length : 3,
    centerPadding: '-15px',
    centerMode: true,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          variableWidth : false,
          arrows : false,
          centerPadding: '0px',
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          variableWidth : false,
          centerPadding: '0px',
        },
      }
    ],
    variableWidth : false
  };

  const settingsOther = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: communitiesOther.length < 3 ? communitiesOther.length : 3,
    centerPadding: '-15px',
    centerMode: true,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          variableWidth : false,
          arrows : false,
          centerPadding: '0px',
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          variableWidth : false,
          centerPadding: '0px',
        },
      }
    ],
    variableWidth : false
  };

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleClick = () => {
    setSeeAll(current => !current);
  };

  const handleClickOther = () => {
    setSeeAllOther(current => !current);
  };

  return (
    <div style={{display: 'flex'}}>
      <Container className={'container'} style={{marginTop: 15}}>
        <Breadcrumbs
          separator="›"
          aria-label="navigation"
          style={{color: mode.settings.textColor3}}>
          {breadcrumbs}
        </Breadcrumbs>

        <Typography
          variant="h5"
          sx={{
            mt: {xs : 2 , md : 2, lg : 2},
            mb: {xs : 4 , md : 4, lg : 2},
            textAlign : {xs : 'center' , md : 'center', lg : 'left'},
          }}
          style={{color: mode.settings.textColor3}}
          id={'anchor0'}
        >
          {' '}
          Mes communautés{' '}

        </Typography>
        {!isLoadingCommunities ? (
          seeAll ? (
            <div style={{marginRight : '-31px'}} >
              <Grid container sx={{mb: 1}}>
                {communities.map((community, index) => (
                  <Grid key={index} item xs={12} lg={4} md={6}>
                    <CommunityCard
                      community={community}
                      sx={{
                        mt: 2,
                        width: {xs : '360px' , md : '380px', lg : '380px'},
                        ml: {xs : 'auto !important' , md : 'auto !important', lg : '0px !important'},
                        mr: {xs : 'auto !important' , md : 'auto !important', lg : '0px !important'},
                      }}
                      member={true}
                    />
                  </Grid>
                ))}
              </Grid>
              <Stack style={{width : '100%'}} direction={'row'} justifyContent={'center'}
                   sx={{
                     mb: {xs : 4 , md : 4, lg : 2},
                     mt: {xs : 4 , md : 4, lg : 2},
                   }}
              >
                <Button
                  className="btn-gradient"
                  startIcon={
                    <RemoveRedEyeIcon
                      role="img"
                      aria-label={'Voir moins de communauté'}
                    />
                  }
                  onClick={handleClick}>
                  Voir moins
                </Button>
              </Stack>
            </div>
          ) : (
            <>
              {
                communities.length > 2 ?
                  <Slider {...settings}>
                    {communities.map((community, index) => (
                      <div key={index}>
                        <CommunityCard
                          community={community}
                          sx={{
                            width: {xs : '360px' , md : '380px', lg : '380px'},
                            ml: {xs : 'auto !important' , md : 'auto !important', lg : '0px !important'},
                            mr: {xs : 'auto !important' , md : 'auto !important', lg : '0px !important'},
                          }}
                          member={true}
                        />
                      </div>
                    ))}
                  </Slider> :
                <Stack direction={'row'} gap={'34px'}>
                {communities.map((community, index) => (
                    <div key={index}>
                      <CommunityCard community={community}
                                     sx={{
                                       width: {xs: '360px', md: '380px', lg: '380px'},
                                       ml: {
                                         xs: 'auto !important',
                                         md: 'auto !important',
                                         lg: '0px !important'
                                       },
                                       mr: {
                                         xs: 'auto !important',
                                         md: 'auto !important',
                                         lg: '0px !important'
                                       },
                                     }}
                                     member={true}
                      />
                    </div>
                ))}
            </Stack>
              }
              <Stack style={{width : '100%'}} direction={'row'} justifyContent={'center'}
                     sx={{
                       mb: {xs : 4 , md : 4, lg : 2},
                       mt: {xs : 4 , md : 4, lg : 2},
                      }}
              >
                <Button
                  className="btn-gradient"
                  style={{width : '325px'}}
                  startIcon={
                    <RemoveRedEyeIcon
                      role="img"
                      aria-label={'Voir mes communautés'}
                    />
                  }
                  onClick={handleClick}>
                  <Typography variant={'subtitle3'}>
                    Voir mes communautés
                  </Typography>
                </Button>
              </Stack>
            </>
          )
        ) : (
          <Stack direction={'row'} spacing={2} sx={{mb: 1, marginTop: 2}}>
            {Array(3)
              .fill('')
              .map(() => (
                <ServiceItemPlaceholder />
              ))}
          </Stack>
        )}
        <Typography
          variant="h5"
          sx={{
            mt: {xs : 2 , md : 2, lg : 2},
            mb: {xs : 4 , md : 4, lg : 2},
            textAlign : {xs : 'center' , md : 'center', lg : 'left'},
          }}
          style={{color: mode.settings.textColor3}}
          id={'anchor1'}
        >
          Découvrir de nouvelles communautés
        </Typography>
        {!isLoadingCommunitiesOther ? (
          seeAllOther ? (
              <div style={{marginRight : '-31px'}}>
              <Grid container sx={{mb: 1}}>
                {communitiesOther.map((community, index) => (
                  <Grid key={index} item xs={12} lg={4} md={6}>
                    <CommunityCard
                      community={community}
                      sx={{
                        mt: 2,
                        width: {xs : '360px' , md : '380px', lg : '380px'},
                        ml: {xs : 'auto !important' , md : 'auto !important', lg : '0px !important'},
                        mr: {xs : 'auto !important' , md : 'auto !important', lg : '0px !important'},
                      }}
                      member={false}
                    />
                  </Grid>
                ))}
              </Grid>
              <div className={'div-btn-center'}>
                <Button
                  className="btn-gradient"
                  startIcon={
                    <RemoveRedEyeIcon
                      role="img"
                      aria-label={'Voir moins de communauté'}
                    />
                  }
                  onClick={handleClickOther}>
                  Voir moins
                </Button>
              </div>
            </div>
          ) : (
            <>
              <Slider {...settingsOther}>
                {communitiesOther.map((community, index) => (
                  <div key={index}>
                    <CommunityCard
                      community={community}
                      sx={{
                        width: {xs : '360px' , md : '380px', lg : '380px'},
                        ml: {xs : 'auto !important' , md : 'auto !important', lg : '0px !important'},
                        mr: {xs : 'auto !important' , md : 'auto !important', lg : '0px !important'},
                      }}
                      member={false}
                    />
                  </div>
                ))}
              </Slider>
              <Stack style={{width : '100%'}} direction={'row'} justifyContent={'center'}
                 sx={{
                   mt: {xs : 2 , md : 2, lg : 2},
                   mb: {xs : 4 , md : 4, lg : 2}
                 }}
              >
                <Button
                  className="btn-gradient"
                  style={{width : '380px'}}
                  startIcon={
                    <RemoveRedEyeIcon
                      role="img"
                      aria-label={'Voir plus de communauté'}
                    />
                  }
                  onClick={handleClickOther}>
                  <Typography variant={'subtitle3'}>Voir toutes les autres communautés</Typography>
                </Button>
              </Stack>
            </>
          )
        ) : (
          <Stack direction={'row'} spacing={2} sx={{mb: 1, marginTop: 2}}>
            {Array(3)
              .fill('')
              .map(() => (
                <ServiceItemPlaceholder />
              ))}
          </Stack>
        )}
      </Container>
      {
        showMoveUpButton ?
            <Box sx={{position: 'fixed', right: 0, top: '25%'}}>
              <IconButton
                  className={'btn-gradient'}
                  sx={{
                    color: '#FFFFFF',
                    borderRadius: 0,
                    borderTopLeftRadius: '10%',
                    borderBottomLeftRadius: '10%'
                  }}
                  onClick={moveUp}
              >
                <ArrowUpwardIcon role="img" aria-label={"Remonter au bloc précédent"}/>
              </IconButton>
            </Box> : <div></div>
      }
      {
        showMoveDownButton ?
            <Box sx={{position: 'fixed', right: 0, top: '32%'}}>
              <IconButton
                  className={'btn-gradient'}
                  sx={{
                    color: '#FFFFFF',
                    borderRadius: 0,
                    borderTopLeftRadius: '10%',
                    borderBottomLeftRadius: '10%'
                  }}
                  onClick={moveDown}
              >
                <ArrowDownwardIcon role="img" aria-label={"Descendre au prochain bloc"}/>
              </IconButton>
            </Box>: <div></div>
      }
    </div>
  );
};

export default Communities;
